<template>

  <header class="main_header">
    <div class="header-wrapper">
      <div class="inner">
        <img src="@/assets/uploads/company.jpg" class="attachment-full size-full">
      </div>
    </div>
  </header>

  <div class="main_content">
    <div class="container-full">
      <div class="inner-content">
        <div style="padding-top:60px;">&nbsp;</div>
        <div class="vc_row wpb_row vc_row-fluid full-w-responsive">
          <div class="wpb_column vc_column_container vc_col-sm-5">
            <div class="vc_column-inner">
              <div class="wpb_wrapper">
                <div class="wpb_single_image wpb_content_element vc_align_right">
                  <figure class="wpb_wrapper vc_figure">
                    <div class="vc_single_image-wrapper  ">
                      <img src="@/assets/images/who-is-green-design.jpg" style="width: 80%;height: 80%"
                           class="vc_single_image-img attachment-full entered lazyloaded"/>
                    </div>
                  </figure>
                </div>
              </div>
            </div>
          </div>
          <div class="padding-side-50px mobile-padding wpb_column vc_column_container vc_col-sm-7">
            <div class="vc_column-inner">
              <div class="wpb_wrapper">
                <div class="wpb_text_column wpb_content_element  no_margin">
                  <div class="wpb_wrapper">
                    <p><span class="title">公司介绍</span></p>
                  </div>
                </div>
                <div class="wpb_text_column wpb_content_element  abt-welcome-content">
                  <div class="wpb_wrapper">
                    <p>
                      上海景幽环境艺术工程有限公司是一家专业的致力于高端绿色环境艺术为中心的绿色产品公司，公司坐落于上海大虹桥枢纽带北面，地理位置优越，交通便利，我们在上海嘉定区有培育基地，部分产品直接从广东直接采购，省区中间环节，集培育、直接采购、设计、生产、售后等产业链服务。 </p>
                    <p>
                      公司成立于2014年，注册资本人民币500万元，公司拥有园艺设计师2名，培育园艺师2名，项目经理2名，园艺养护师13名，其中公司风景园林专业的2名，专科以上学历3名，植物配送车辆3辆。我们优秀的团队为您提供优质的服务，是您的信赖和放心，我们专注于优质环境绿化事业。 </p>
                    <p>
                      我们的绿色产品定位为中高档次，有别于传统的绿化公司，我们的每一系列绿色产品均经过设计产生，整体的搭配及组合都有极高的艺术价值，不仅能提高您的环境质量水平，更能提高您的环境艺术水平，能为您的幽雅环境舒适度提供保障，让您的生活变得绚丽多彩，在幽雅多氧的环境中享受高品质的生活。 </p>
                    <p>
                      随着人们生活水平的逐步提高，结合现在城市环境的污染状况，人们一般比较倾向于建造属于自己绿色环境，因为人们经常处在一个封闭的办公空间或者居室空间，门窗紧闭，环境空气含氧量很低，加之装修后所产生的化工有毒气体，使人经常感觉疲惫无力和缺氧不适，严重影响人的健康。我们的目标就是想为你和你们创造一个绿色、环氧、除雾霾、优美的办公环境和居住环境。 </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="vc_row wpb_row vc_row-fluid mobile-padding full-w-responsive vc_row-o-equal-height vc_row-flex">
          <div class="padding-left-50px wpb_column vc_column_container vc_col-sm-5">
            <div class="vc_column-inner">
              <div class="wpb_wrapper">
                <div class="wpb_text_column wpb_content_element ">
                  <div class="wpb_wrapper">
                    <p><strong>服务团队</strong></p>
                    <p>我们30%以上的员工工作了10年以上，这充分说明了我们公司的情况 以及我们坚持的标准。我们通过自己的合作为客户取得了更多成就，并享受了更好的工作环境。</p>
                    <p> 我们的服务地理范围：</p>
                     <div>● 室内绿色环境部分目前服务范围仅限上海地区</div>
                     <div>● 室外部分景观工程和花园造景及园林工程服务范围为全国</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="wpb_column vc_column_container vc_col-sm-7">
            <div class="vc_column-inner">
              <div class="wpb_wrapper">
                <div class="wpb_single_image wpb_content_element vc_align_center">

                  <figure class="wpb_wrapper vc_figure">
                    <div class="vc_single_image-wrapper  ">
                      <img style="width: 80%;height: 80%" src="@/assets/images/img_about_02.jpg"
                           class="vc_single_image-img attachment-full entered lazyloaded">
                    </div>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script setup>
</script>